module.exports = __webpack_public_path__ + "img/storeroom-hover.5ab5ff49.png";